import Vue from 'vue'
import VueRouter from 'vue-router'
import Home from '../views/Home.vue'
import Oauth2 from '../components/Oauth2.vue'

import Account from '../views/Account.vue'
import Acercade from '../views/AcercaDe.vue'
import Legal from '../views/Legal.vue'
import Ecommerce from '../components/resources/Ecommerce.vue'

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'Home',
    component: Home,
    children: [
      {
        path: 'validate/:access',
          name: 'acceso',
          component: Home
      }
    ]
  },
  {
    path: '/Acercade',
    name: 'Acercade',
    component: Acercade
  },
  {
    path: '/Legal',
    name: 'legal',
    component: Legal
  },
  {
    path: '/resources/ecommerce',
    name: 'resources',
    component: Ecommerce
  },
  {
    path: '/login/:vertical',
    name: 'oauth2-type',
    component: Oauth2
  },

  {
    path: '/account',
    name: 'account',
    component: Account
  },
  {
    path: '/about',
    name: 'About',
    component: () => import('../views/About.vue')
  }
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})

export default router
